










































import BaseComponent from '@/components/base-component.vue';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import { MedidasProdutosEnteralResult } from '@/interfaces/product';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import * as prescService from '@/services/prescription';
import * as service from '@/services/prescription-templates';
import { PATTERN } from '@/settings/consts/prescriptions-types';
import { BehaviorSubject, of, timer } from 'rxjs';
import { catchError, debounce, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PatternPreviewMenu from './pattern-preview-menu.vue';



@Component({components: {PatternPreviewMenu}})
export default class PrescriptionTypesPattern extends BaseComponent {
  
  @Prop()
  public item;
  @Prop()
  public currentTab: string;
  @Prop()
  public tabName: string;
  @Prop()
  public enteralResult: MedidasProdutosEnteralResult;
  @Prop()
  public draft: PrescricaoParmDTO;

  public loading: boolean = false;
  public items: any[] = [];
  public selectedItem: any = {};
  public template: any = null;

  private recalc$: BehaviorSubject<any> = new BehaviorSubject('initialize');

  idPreview = null;
  menuX = 0;
  menuY = 0;
  activator = null;

  @Watch('item.unidade')
  public onChangeUnit(val: any): void {
    this.load();
  }

  @Watch('item.paciente')
  public onChangePatient(val: any): void {
    this.load();
  }

  @Watch('currentTab')
  public onChangeCurrentTab(): void {
    if (this.currentTab === this.tabName) {
      this.selectedItem = null;
    }
    this.onChangeDraft(this.draft);
  }

  @Watch('item.volumeDesejado')
  public onChangeVolume(): void {
    if (!this.item.volumeDesejado || !this.item.isPattern() || (this.enteralResult && this.enteralResult.idEnteral)) {
      return;
    }

    this.recalc$.next('validate');
  }

  @Watch('draft', {immediate: true})
  public onChangeDraft(draft:PrescricaoParmDTO): void {
    if (!draft || !draft.idTemplate || draft.tipoPrescricao != PATTERN) {
      return;
    }

    this.selectItemWhenReady(draft.idTemplate);
  }

  selectItemWhenReady(idTemplate) {
    this.sleepUntil(() => {
      return this.items && this.items.length;
    }, 180000).then(() => {      
      this.selectedItem = this.items.find((i) => Number(i.id) == idTemplate);
      this.onChangeSelectedItem(this.selectedItem);
    });
  }  
  
  public onChangeSelectedItem(val: any) {
    if (!val || !val.id) {
      return;
    }

    this.loader.start();
    prescService.getPrescriptionTemplate(val.id).subscribe((data) => {
      this.template = new PrescriptionTemplateModel(data);
      this.$emit('change', this.template);
      this.loader.stop();
    }, error => {
      this.showToastApiError(error);
      this.loader.stop();
    });
  }

  public beforeMount(): void {
    this.load();
    this.subscribeRecalc();
  }

  public showEmptyState(): boolean {
    return (
      !this.loading &&
      !this.items.length &&
      !!this.item.paciente &&
      !!this.item.paciente.id &&
      !!this.item.unidade &&
      !!this.item.unidade.id
    );
  }

  public load(): void {
    this.selectedItem = {};
    this.items = [];

    if (
      !this.item.unidade ||
      !this.item.unidade.id ||
      !this.item.paciente ||
      !this.item.paciente.tipo
    ) {
      return;
    }

    this.loading = true;

    service.getPrescriptionTemplatesCombo(this.item.unidade.id, this.item.paciente.tipo.id).subscribe(
      (data) => {
        this.items = data;
        if (this.item.template && this.item.template.id){
          this.selectedItem = data.filter(item => item.id == this.item.template.id)[0];          
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      },
    );
  }

  private subscribeRecalc() {
    this.recalc$
      .pipe(
        skipWhile((val) => {
          return val === 'initialize';
        }),
        debounce(() => {
          return timer(1500);
        }),
        switchMap((data) => {
          return service.recalcPatternValues(this.selectedItem.id, this.item.volumeDesejado).pipe(
            catchError((err) => {
              this.toast.show(
                'Houve um erro ao recalcular os valores',
                'error',
              );
              return of(false);
            }),
          );
        }),
      )
      .subscribe((data) => {
        if (data) {
          this.template.produtos = data.produtos;
          this.template.volumeDesejado = this.item.volumeDesejado;
          this.$emit('change', this.template);
        }
      });
  }

  onShowPreview(item, e) {
    this.idPreview = item.id;
    this.menuX = e.clientX + 20;
    this.menuY = e.clientY;
    this.activator = e.currentTarget;
  }

  onClosePreview() {
    this.idPreview = null;
  }
}
